import { userNameID } from "@shared/model/comment-aggrigator-model";
import { ActivitiesActorAndAffected } from "@shared/model/activities-aggrigator-model";
import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { ObjectTypeEnum } from "@shared/model/enum/object-type-enum";
import { UserTypeEnum } from "@shared/model/enum/user-type-enum";

export class UserActivityInfoModel {
  userId!: string;
  bookId?: string;
  pageNum!: number
  userName!: string;
  activityId!: string;
  userFullname!: string;
  activityText!: string;
  activityDate!: string;
  textReadTime?: string;
  userHasPhoto!: boolean;
  userType!: UserTypeEnum;
  hasOtherObjects!: boolean;
  activityObjectId?: string;
  includeImageIcon?: boolean;
  activityVerb!: ActivityVerbEnum;
  activityObjectType?: ObjectTypeEnum;
  hasReply?: boolean;
  replyUser?: userNameID;
  affectedUser?: ActivitiesActorAndAffected;
  totalLikesCount?: number;
  reactedId?: string;
}
